/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Card from '../components/Card';
import Form from '../components/Form';
import { USER_ADD_OPTIONS, USER_MODAL_TYPE } from '../enum/object';
import { StepFooter } from './commons';
import './modals.scss';

function UserCreationSelection({ onNext, navigateBack }) {
  const [method, setMethod] = useState('');

  const changeField = (field, value) => {
    if (field !== 'method') {
      return;
    }

    setMethod(value);
    if (value === '1') {
      onNext(USER_MODAL_TYPE.CREATE_USER);
    } else if (value === '2') {
      onNext(USER_MODAL_TYPE.IMPORT_USER);
    }
  };

  return (
    <div>
      <div className="modal__content padded ldap-config user-creation-selection">
        <Card header={false}>
          <div className="ldap-config-connection">
            <div className="form-header desc-header">
              <h5 className="form-header desc-header">
                Add users to your ecosystem to let them connect using their access credentials, like username and
                password.
              </h5>
              <div className="form-body">
                <div className="header-block">
                  <h5>Please select source of your users</h5>
                </div>
                <div className="selection-method">
                  <div className="form__input form__radioGroup">
                    {USER_ADD_OPTIONS.map((option, i) => (
                      <div className="form-row" key={i}>
                        <Form.RadioButton
                          key={i}
                          {...option}
                          selected={method}
                          onChange={(value) => {
                            changeField('method', value);
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
      {!method && (
        <div className="wedge-modal__footer">
          <StepFooter submit={false} onBack={navigateBack} forwardNav={false} backwardNav />
        </div>
      )}
    </div>
  );
}

UserCreationSelection.propTypes = {
  onNext: PropTypes.func.isRequired,
  navigateBack: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default UserCreationSelection;
